import { OFFICE_CLOSED } from '@/config/constants'

export default function state() {
	return {
		officeOpenInfo: {
			active: false,
			indicator: OFFICE_CLOSED,
			visible: false,
		},

		alertSettingsPopup: {
			visible: false,
		},

		alertPreferences: {
			id: null,
			audio_alert_enabled: false,
			visual_alert_enabled: false,
			inactivity_threshold_minutes: 5,
			alert_sound: null,
			alert_color: 'orange',
		},
	}
}
